import { ErrorParser } from "../ErrorParser";
import { isObject } from "lodash-es";

/**
 * Ej: Pyramid already exist
 */
export class PiramideExistenteParser implements ErrorParser {
    public puedeLeerError(error: string): boolean {
        return !isObject(error) && error.includes("Pyramid") && error.includes("already exist");
    }

    public traducir(): string {
        return "Ya existe una piramide para ese pais";
    }
}
